module.exports = __webpack_public_path__ + "img/img_stone.f39f7e99.png";